import { Box } from '@mui/material';
import icon from '../images/loader-image.png';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'block',
        position: 'fixed',
        backgroundColor: '#edf1f2',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100px',
          height: '100px',
          backgroundImage: `url(${icon})`,
          backgroundSize: '75px 75px',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          borderRadius: '60px',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: '-6px',
            right: '-6px',
            bottom: '-6px',
            left: '-6px',
            borderRadius: '60px',
            border: '3px solid transparent',
            borderColor: '#fff',
            zIndex: 10
          },
          '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100px',
            height: '100px',
            background: '#edf1f2',
            animation: 'loader 2s linear infinite'
          }
        }}
      />
      <style>
        {`
          @keyframes loader {
            from {
              height: 100%;
            }
            to {
              height: 0;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default LoadingScreen;
